import React, { ComponentType } from 'react';

import { MapContext } from './hooks/useMap';

export const withMap =
  <T extends object>(Component: ComponentType<T>) =>
  (props: T) => (
    <MapContext.Consumer>
      {(mapProps) => <Component {...mapProps} {...(props as T)} />}
    </MapContext.Consumer>
  );
